import React from "react";
import { Col, Row } from "react-bootstrap";
import Ansible from "../../Assets/About/Skillset/Ansible.webp";
import Aruba from "../../Assets/About/Skillset/Aruba.svg";
import Bash from "../../Assets/About/Skillset/Bash.svg";
import Cisco from "../../Assets/About/Skillset/Cisco.svg";
import Esxi from "../../Assets/About/Skillset/Esxi.svg";
import Exchange from "../../Assets/About/Skillset/Exchange.svg";
import Linux from "../../Assets/About/Skillset/Linux.webp";
import Microsoft365 from "../../Assets/About/Skillset/Microsoft365.svg";
import Nagios from "../../Assets/About/Skillset/Nagios.webp";
import Pfsense from "../../Assets/About/Skillset/Pfsense.webp";
import Powershell from "../../Assets/About/Skillset/PowerShell.svg";
import Stormshield from "../../Assets/About/Skillset/Stormshield.webp";
import Unifi from "../../Assets/About/Skillset/Ubiquiti.svg";
import Veeam from "../../Assets/About/Skillset/Veeam.webp";
import Windows from "../../Assets/About/Skillset/Windows.webp";
import Zabbix from "../../Assets/About/Skillset/Zabbix.svg";

function Techstack() {
  return (
    <Row style={{ justifyContent: "center", paddingBottom: "50px" }}>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Ansible} alt="Ansible" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Ansible</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Aruba} alt="Aruba" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Aruba</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Bash} alt="Bash" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Bash</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Cisco} alt="Cisco" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Cisco</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Esxi} alt="Esxi" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">ESXi</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Exchange} alt="Exchange" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Exchange</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Linux} alt="Linux" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Linux</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Microsoft365} alt="Microsoft365" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Microsoft365</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Nagios} alt="Nagios" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Nagios</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Pfsense} alt="Pfsense" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Pfsense</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Powershell} alt="Powershell" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Powershell</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Stormshield} alt="Stormshield" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Stormshield</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Unifi} alt="Unifi" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Unifi</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Veeam} alt="Veeam" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Veeam</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Windows} alt="Windows" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Windows</div>
      </Col>
      <Col xs={4} md={2} className="tech-icons">
        <img src={Zabbix} alt="Zabbix" style={{width: "24px", height: "24px",}} />
        <div className="tech-icons-text">Zabbix</div>
      </Col>
    </Row>
  );
}
export default Techstack;
